import { render } from "./AgingInsuranceTable.vue?vue&type=template&id=8687a422"
import script from "./AgingInsuranceTable.vue?vue&type=script&lang=js"
export * from "./AgingInsuranceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__